import { init } from './MallCPA14';
init();
